// The waitlist at the door of the signed-in app (28 Oct 2026): an account on the ECONIC waitlist sees the waiting room instead of ECONIC.
// The server is the gate (EconicWaitlistGateMiddleware refuses every other ECONIC route to a waitlisted session); this only spares the
// person a shell full of refusals. The last state is remembered in the browser so an admitted person never waits for the check; a stack
// without engagement (404) or a failed check opens ECONIC as before.
import { lazy, Suspense, useEffect, type ReactNode } from "react";
import { useEngagementMe } from "./api";

const WaitingRoom = lazy(() => import("./WaitingRoom").then((m) => ({ default: m.WaitingRoom })));
const KEY = "econic.access";

function remembered(): string | null {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
}

export function WaitlistGate({ children }: { children: ReactNode }) {
  const last = remembered();
  const me = useEngagementMe({ poll: last === "waitlist" });
  const state = me.data?.state ?? null;
  useEffect(() => {
    if (!state) return;
    try { window.localStorage.setItem(KEY, state); } catch { /* private window */ }
  }, [state]);

  if (me.data?.state === "waitlist") return <Suspense fallback={null}><WaitingRoom me={me.data} /></Suspense>;
  if (me.isLoading && last !== "admitted") return null;
  return <>{children}</>;
}
